/* eslint-disable no-underscore-dangle */
import Backend from 'i18next-xhr-backend';

/*
   The seismicI18nBackend class is inherit from Backend i18n plugin.
   Here we rewrite the loadUrl method in which we could get the
   seismic cdn async and keep the indicator working while both get
   the i18n resource and seismic cdn url.
*/

class seismicI18nBackend extends Backend {
    constructor(services, options = {}) {
        super(services, options);
    }

    loadUrl(url, callback) {
        if (window.seismicSDSResponse &&
            window.seismicSDSResponse.serviceAddress &&
            window.seismicSDSResponse.serviceAddress.webcdn) {
            super.loadUrl(window.seismicSDSResponse.serviceAddress.webcdn.concat(url), callback);
            return;
        }

        super.loadUrl('https://cdn-prod.seismic.com'.concat(url), callback);
    }
}

seismicI18nBackend.type = 'backend';

export default seismicI18nBackend;
